import { render, staticRenderFns } from "./CustomRoundBtn.vue?vue&type=template&id=6825f7c2&scoped=true&lang=pug"
import script from "./CustomRoundBtn.vue?vue&type=script&lang=js"
export * from "./CustomRoundBtn.vue?vue&type=script&lang=js"
import style0 from "./CustomRoundBtn.vue?vue&type=style&index=0&id=6825f7c2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6825f7c2",
  null
  
)

export default component.exports